import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { Box } from '@mui/material';
import ChampionshipDetailContent from '../../components/championship/ChampionshipDetailContent';
import ContentArea from '../../components/contentArea';
import Navigation from '../../components/navigation';
import { ChampionshipBackground } from '../../assets/images/championshipBackground';

export const ChampionshipUserDetail = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    // 전달받은 챔피언십 데이터
    const championshipData = location.state?.championshipData;

    // 챔피언십 데이터가 없으면 메인으로 리다이렉트
    useEffect(() => {
        if (!location.state?.championshipData) {
            navigate('/', { replace: true });
            return;
        }
    }, [location.state, navigate, location.pathname]);

    if (!championshipData) {
        return null;
    }

    return (
        <ContentArea sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            position: 'relative',
            overflow: 'hidden',
        }}>
            {/* Background */}
            <Box sx={{
                position: 'absolute',
                top: '-50px', // 노치 높이만큼 위로 이동
                left: 0,
                width: '100%',
                display: 'flex',
                alignItems: 'stretch',
                justifyContent: 'stretch'
            }}>
                <ChampionshipBackground sx={{ width: '100%', height: '100%' }} />
            </Box>

            {/* Navigation */}
            <Box sx={{
                width: '100%',
                padding: '0 10px',
                flexShrink: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                zIndex: 2
            }}>
                <Navigation title={t('participant_ranking')} />
            </Box>

            {/* Championship Detail Content */}
            <ChampionshipDetailContent
                championshipData={championshipData}
            />
        </ContentArea>
    );
};

export default ChampionshipUserDetail;
